import React from 'react';
import { useLocation } from 'react-router-dom';

const PaymentSuccess = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get('order_id');
  /** В URL от бэкенда (СБП/Aurapay/Pay1Time) передаётся сумма пополнения Steam в USD, не рублях */
  const amountUsd = searchParams.get('amount');

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Иконка успеха */}
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Заголовок */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Платеж успешно завершен!
        </h1>

        {/* Описание */}
        <p className="text-gray-600 mb-6">
          Платеж успешен! Steam аккаунт будет пополнен в ближайшее время.
        </p>

        {/* Детали платежа */}
        {orderId && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="text-sm text-gray-500 mb-2">Детали платежа:</div>
            <div className="text-lg font-semibold text-gray-900">
              Заказ №{orderId}
            </div>
            {amountUsd && (
              <div className="text-lg font-semibold text-green-600 mt-2">
                Сумма пополнения Steam:{' '}
                <span className="whitespace-nowrap">${amountUsd} USD</span>
              </div>
            )}
          </div>
        )}

        {/* Информационное сообщение */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <div className="text-left">
              <p className="text-blue-800 text-sm font-medium mb-1">
                Steam аккаунт будет пополнен в ближайшее время
              </p>
              <p className="text-blue-700 text-xs">
                Если в течение часа пополнения не будет, сообщите номер заказа <span className="font-mono font-bold">{orderId || 'XXXXX'}</span> в техподдержку: <a href={process.env.REACT_APP_SUPPORT_URL} className="underline hover:no-underline">@tp_trendy_eng_shop</a>
              </p>
            </div>
          </div>
        </div>

        {/* Кнопки действий */}
        <div className="space-y-3">
          <button
            onClick={() => window.location.href = '/steam/topup'}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Вернуться к пополнению
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
          >
            На главную
          </button>
        </div>

        {/* Дополнительная информация */}
        <div className="mt-8 text-sm text-gray-500">
          <p>Если у вас возникли вопросы, обратитесь в поддержку:</p>
          <a 
            href={process.env.REACT_APP_SUPPORT_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 font-semibold"
          >
            @tp_trendy_eng_shop
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
